<template>
    <div class="border rounded-lg bg-gray-50 border-gray-200 notifications-preferences">
        <div class="flex justify-between items-center bottom-line p-4">
            <h6 v-if="! editing" class="text-base font-semibold">Notification Preferences</h6>
            <h6 v-else @click="cancelEdit" class="cursor-pointer text-base font-semibold cancel-save-notifications-button">Cancel</h6>
            <a v-if="! editing" @click.prevent="startEditing" class="cursor-pointer font-semibold no-underline text-sm edit-button">Edit</a>
            <a v-else @click.prevent="save" class="cursor-pointer font-semibold no-underline text-sm save-notifications-button">
                <template v-if="! editingLoading">
                    Save Changes
                </template>
                <template v-else>
                    <i class="fa fa-circle-notch fa-spin" />
                </template>
            </a>
        </div>
        <div>
            <div class="bottom-line p-4 flex justify-between items-center unsubscribe-groups" v-for="(unsubs, i) in unsubscribeGroupsCopy" :key="i">
                <p>{{ unsubs.name }}</p>
                <p>
                    <input 
                        class="bg-gray-50 border-gray-300 rounded unsubscribe-checkbox" 
                        type="checkbox"
                        :value="unsubs.id"
                        :checked="isChecked(unsubs.id)"
                        @change="toggleCheckbox(unsubs.id, $event.target.checked)"
                        :disabled="!editing"
                    />
                </p>
            </div>

            <div class="bottom-line p-4 flex justify-center items-center error-container" v-if="errorOnSave">
                <p class="font-semibold">Error on save.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { set } from 'lodash';
export default {
    props: {
        unsubscribegroups: {
            type: Array,
            default: () => []
        },
        userunsubscribegroups: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            editing: false,
            editingLoading: false,
            errorOnSave: false,
            unsubscribeUserIds: [],
            originalUnsubscribeUserIds: [], // to implement cancel
            unsubscribeGroupsCopy: [],
            unsubscribeUserIdsInitials: []
        }
    },
    created: function() {
        this.unsubscribeGroupsCopy = this.unsubscribegroups;
        this.unsubscribeUserIdsInitials = this.userunsubscribegroups.map(group => group.id);
        this.setInitialState(); 
    },
    methods: {

        getChecked(unsubscribeGroupId) {
            return !this.unsubscribeUserIds.includes(unsubscribeGroupId);
        },

        setInitialState() {
            this.editing = false;
            this.editingLoading = false;
            this.unsubscribeUserIds = this.getUserUnsubscribeIds();
            this.originalUnsubscribeUserIds = [...this.unsubscribeUserIds];
        },

        getUserUnsubscribeIds() {
            return this.unsubscribeUserIdsInitials;
        },

        isChecked(unsubscribeGroupId) {
            return !this.unsubscribeUserIds.includes(unsubscribeGroupId);
        },

        toggleCheckbox(unsubscribeGroupId, isChecked) {
            if (isChecked) {
                this.unsubscribeUserIds = this.unsubscribeUserIds.filter(id => id !== unsubscribeGroupId);
            } else {
                this.unsubscribeUserIds.push(unsubscribeGroupId);
            }
        },

        startEditing() {
            this.editing = true;
            this.originalUnsubscribeUserIds = [...this.unsubscribeUserIds];
        },

        cancelEdit() {
            this.editing = false;
            this.unsubscribeUserIds = [...this.originalUnsubscribeUserIds];
        },

        save() {
            this.editingLoading = true;
            axios.post('/account/profile/notification-preferences', {
                unsubscribe_groups: this.unsubscribeUserIds
            })
            .then(response => {
                this.editing = false;
                this.editingLoading = false;
                this.unsubscribeUserIdsInitials = this.unsubscribeUserIds;
            })
            .catch(error => {
                this.editingLoading = false;
                this.errorOnSave = true;

                setTimeout(() => {
                    this.errorOnSave = false;
                }, 5000);
            });
        }
    }
}

</script>

<style scoped>
    input[disabled="disabled"] {
        cursor: not-allowed;
        opacity: 0.75;
    }

    .error-container p {
        color: #ff6060
    }
</style>